import React from 'react'

export default function DrinkSvg() {
  return (
    <div>
       <svg fill="currentColor" version="1.1" id="Uploaded to svgrepo.com" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="34px" height="34px" viewBox="0 0 32 32" style={{enableBackground: "new 0 0 32 32"}} xmlSpace="preserve">

<path fill="currentColor" className="feather_een" d="M29.146,5.854C29.461,5.539,29.238,5,28.793,5h-4.086l2.049-2.049C26.836,2.971,26.914,3,27,3
	c0.629,0,1.123-0.581,0.973-1.236c-0.083-0.361-0.376-0.655-0.738-0.737C26.581,0.878,26,1.371,26,2
	c0,0.086,0.029,0.164,0.049,0.244L23.293,5H3.207C2.762,5,2.539,5.539,2.854,5.854L15.5,18.5V29h-5c-0.276,0-0.5,0.224-0.5,0.5v0
	c0,0.276,0.224,0.5,0.5,0.5h11c0.276,0,0.5-0.224,0.5-0.5v0c0-0.276-0.224-0.5-0.5-0.5h-5V18.5L29.146,5.854z M23.707,6h3.879l-1,1
	h-3.879L23.707,6z M4.414,6h17.879l-1,1h-0.059c-0.41-0.289-0.839-0.438-1.281-0.438c-0.496,0-0.919,0.184-1.296,0.438H5.414
	L4.414,6z M20.623,10.561c-0.483,0.483-0.941,0.877-1.452,0.877c-0.315,0-0.65-0.15-1.023-0.523
	c-0.976-0.976-0.427-1.694,0.354-2.475c0.483-0.483,0.941-0.877,1.452-0.877c0.315,0,0.65,0.15,1.023,0.523
	C21.953,9.062,21.404,9.78,20.623,10.561z M16,17.586L6.414,8h11.121c-0.598,0.645-1.455,1.835-0.448,3.206L14,14.293
	c-0.195,0.195-0.195,0.512,0,0.707s0.512,0.195,0.707,0l3.081-3.081c0.441,0.34,0.904,0.518,1.384,0.518
	c0.913,0,1.593-0.604,2.159-1.17C21.841,10.757,23.094,9.5,22.179,8h3.407L16,17.586z"/>
</svg>
    </div>
  )
}